import {
  DeviceTypeSchema,
  MessageSchema,
} from "@deskpro-product/messenger-api-schemas/messenger/api/conversation/entities";
import { RoutePath } from "@deskpro-product/messenger-api-schemas/messenger/config/routes";
import type { Static } from "@deskpro-product/messenger-api-schemas/typebox";
import { Type } from "@deskpro-product/messenger-api-schemas/typebox";

// TODO: Had to dupe this schema from the messenger-api-schemas package as even though we don't use `format: date-time` in the schema
// it still seems to be causing issues with the generated code??? Maybe caching but I couldn't get rid of it.
const UserConfirmationMethodSchema = Type.Union([Type.Literal("jwt"), Type.Literal("email_code")]);
const UserConfirmationSchema = Type.Object({
  isConfirmed: Type.Boolean(),
  method: Type.Optional(UserConfirmationMethodSchema),
  confirmedAt: Type.Optional(Type.String()),
});

export const localStorageStateSchema = Type.Object({
  /**
   * User's device. device_id is used as the primary identifier for guest users
   * Every user must have a device id, generated automatically on first load
   */
  device: Type.Object({
    device_id: Type.String(),
    type: DeviceTypeSchema,
  }),

  userConfirmed: UserConfirmationSchema,

  /** Conversations and their last active time and optional record of unsent messages */
  conversations: Type.Optional(
    Type.Array(
      Type.Object({
        id: Type.String(),
        // Datetime of last message as ISO string
        lastActive: Type.String(),
        unsentMessages: Type.Optional(
          Type.Record(
            Type.String({
              title: "MessageId",
            }),
            MessageSchema,
          ),
        ),
      }),
    ),
  ),
  /** The last tab the user visited */
  lastVisited: Type.Optional(
    Type.Union([
      Type.Object({
        tab: RoutePath,
      }),
      Type.Object({
        tab: Type.Literal("conversation"),
        id: Type.String(),
      }),
    ]),
  ),
  /** The last ROUTE the user visited (not the same as tab) */
  lastRouteVisited: Type.Optional(RoutePath),

  /** The time at which the user clicked the Notifications panel "Deny" button. If this is set we will not show the Notifications panel again. */
  notificationsDeniedAt: Type.Optional(Type.String()),
  /** Messenger auth token. */
  auth: Type.Optional(Type.String()),

  /** The current locale */
  locale: Type.String(),

  /** If the app was closed by the user. This is used to prevent auto re-opening the app when there is an active conversation but the user previously closed the widget */
  wasClosed: Type.Optional(Type.Boolean()),
});

export type LocalStorageState = Static<typeof localStorageStateSchema>;

export type LocalStorageStateChat = NonNullable<LocalStorageState["conversations"]>[number];
export type LocalStorageChat = Omit<LocalStorageStateChat, "lastActive"> & { lastActive: Date };
